import classNames from 'classnames';
import React from 'react';

type Props = {
  className?: string,
  children: React.ReactNode,
  index: number,
  activeIndex: number
};

class Tab extends React.Component<Props> {
  override render (): React.ReactNode {
    const { children, className, index, activeIndex } = this.props;

    return (
      <div className={classNames(className, 'esko_tab', {esko_tabvisible: index === activeIndex})}>
        {children}
      </div>
    );
  }
}

export default Tab;
